// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../lib/firebase';

export function useAuth() {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const login = async (email, password) => {
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(friendlyError(err.code));
    }
  };

  const register = async (email, password) => {
    setError('');
    try {
      await createUserWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(friendlyError(err.code));
    }
  };

  const logout = () => signOut(auth);

  return { user, loading, error, login, register, logout };
}

function friendlyError(code) {
  const map = {
    'auth/user-not-found':       'No account found with that email.',
    'auth/wrong-password':       'Incorrect password.',
    'auth/invalid-email':        'Please enter a valid email address.',
    'auth/email-already-in-use': 'An account with this email already exists.',
    'auth/weak-password':        'Password must be at least 6 characters.',
    'auth/too-many-requests':    'Too many attempts. Please try again later.',
    'auth/invalid-credential':   'Incorrect email or password.',
  };
  return map[code] || 'Something went wrong. Please try again.';
}



// // src/hooks/useAuth.js
// // ─────────────────────────────────────────────────────────
// // Manages Firebase auth state. Used once at the App root.
// // ─────────────────────────────────────────────────────────

// import { useState, useEffect } from "react";
// import { auth, signInAnonymously, onAuthStateChanged } from "../lib/firebase";

// export function useAuth() {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Sign in anonymously so every visitor gets a unique, persistent UID.
//     // If you later add Google/email auth, swap this out here — nothing else changes.
//     signInAnonymously(auth).catch(console.error);

//     const unsub = onAuthStateChanged(auth, (u) => {
//       setUser(u);
//       setLoading(false);
//     });

//     return unsub;
//   }, []);

//   return { user, loading };
// }
